import Header from "./Components/Header.jsx";
import Navbar from "./Components/Navbar.jsx";
import Home from "./Components/Home.jsx";
import Study from "./Components/Study.jsx";
import Visa from "./Components/Visa.jsx";
import Work from "./Components/Work.jsx";
import Migrate from "./Components/Migrate.jsx";
import Footer from "./Components/Footer.jsx";
import Coaching from "./Components/Coaching.jsx";
import Visit from "./Components/Visit.jsx";
import About from "./Components/About.jsx";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AnimatePresence, motion } from "motion/react";
import "./App.css";
import "./Styles/MobileResponsive.css";
import Consultation from "./Components/Consultation.jsx";
import LibaMigration from "./Components/LibaMigration.jsx";
import FloatingLibaButton from "./Components/FloatingLibaButton.jsx";
import BackToTop from "./Components/BackToTop.jsx";
import Blog from "./Components/Blog.jsx";
import BlogPost from "./Components/BlogPost.jsx";
import PrivacyPolicy from "./Components/PrivacyPolicy.jsx";
import TermsConditions from "./Components/TermsConditions.jsx";
import FAQ from "./Components/FAQ.jsx";
import EuropeVisa from "./Components/EuropeVisa.jsx";
import StudyVisa from "./Components/StudyVisa.jsx";
import FloatingWhatsApp from "./Components/FloatingWhatsApp.jsx";
import LatviaTRP from "./Components/LatviaTRP.jsx";
import CanadaPR from "./Components/CanadaPR.jsx";
import Newsletters from "./Components/Newsletters.jsx";
import NewsletterPost from "./Components/NewsletterPost.jsx";
import VeaPromises from "./Components/VeaPromises.jsx";
import OurOffice from "./Components/OurOffice.jsx";
import PlanePreloader from "./Components/PlanePreloader.jsx";
import ScrollFlightProgress from "./Components/ScrollFlightProgress.jsx";
import CursorSpotlight from "./Components/CursorSpotlight.jsx";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        className="va-route-transition"
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -14 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/study" element={<Study />} />
          <Route path="/visa" element={<Visa />} />
          <Route path="/work" element={<Work />} />
          <Route path="/migrate" element={<Migrate />} />
          <Route path="/coaching" element={<Coaching />} />
          <Route path="/visit" element={<Visit />} />
          <Route path="/about" element={<About />} />
          <Route path="/consultationForm" element={<Consultation />} />
          <Route path="/LibaMigration" element={<LibaMigration />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/europe-visa" element={<EuropeVisa />} />
          <Route path="/study-visa" element={<StudyVisa />} />
          <Route path="/latvia-trp" element={<LatviaTRP />} />
          <Route path="/canada-pr" element={<CanadaPR />} />
          <Route path="/newsletters" element={<Newsletters />} />
          <Route path="/newsletter/:slug" element={<NewsletterPost />} />
          <Route path="/vea-promises" element={<VeaPromises />} />
          <Route path="/office" element={<OurOffice />} />
          <Route path="/our-office" element={<OurOffice />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  return (
    <Router>
      <PlanePreloader />
      <ScrollFlightProgress />
      <CursorSpotlight />
      <div className="App">
        <ScrollToTop />
        <FloatingLibaButton />
        <BackToTop />
        <FloatingWhatsApp />
        <header className="App-header">
          <Header />
          <Navbar />
        </header>
        <AnimatedRoutes />
        <footer className="App-footer">
          <Footer />
        </footer>
      </div>
    </Router>
  );
}

export default App;